import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const FaqSection = ({ data }) => {
    if (!data || !data.faqs || data.faqs.length === 0) return null;
    const { title, description, faqs } = data;

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="py-8 md:py-16 bg-white w-full">
            <div className="container mx-auto px-4 max-w-4xl">
                {/* Header */}
                <div className="text-center mb-6 md:mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        {title || "الأسئلة الشائعة"}
                    </h2>
                    {description && (
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            {description}
                        </p>
                    )}
                </div>

                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 ${
                                openIndex === index
                                    ? "bg-blue-50/50 border-blue-100 shadow-sm"
                                    : "bg-white hover:border-blue-200 hover:bg-gray-50/50"
                            }`}
                        >
                            <button
                                onClick={() => toggleFaq(index)}
                                className="w-full flex items-center justify-between p-5 text-right focus:outline-none gap-4"
                            >
                                <span
                                    className={`font-semibold text-lg leading-relaxed ${openIndex === index ? "text-blue-700" : "text-gray-800"}`}
                                >
                                    {faq.question}
                                </span>
                                <div
                                    className={`p-1 rounded-full ${openIndex === index ? "bg-blue-100" : "bg-gray-100"}`}
                                >
                                    {openIndex === index ? (
                                        <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" />
                                    ) : (
                                        <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                                    )}
                                </div>
                            </button>

                            <div
                                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                                    openIndex === index
                                        ? "max-h-[500px] opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-blue-100/50">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
